// src/features/townBudget/components/programs/Program_Intergovernmental.jsx

import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

/**
 * Intergovernmental: Combined Rollup
 * Firestore docId:
 *   revenues_intergovernmental
 *
 * Display order (left-to-right):
 *   HousAuth In-Lieu Tax
 *   St Conn In-Lieu Taxes
 *   ST Educ Entitlements
 *   Admin Services
 *   Public Safety
 *   Human Services
 */
export const PROGRAM_INTERGOVERNMENTAL_CONFIG = {
  fullName: "Intergovernmental",
  docId: "revenues_intergovernmental",

  fieldDefs: [
    // -------------------------
    // HousAuth In-Lieu Tax
    // -------------------------
    {
      key: "housAuthWellesVillage",
      label: "Housing Auth Welles Village",
      valueType: "currency",
      sources: [{ block: "HousAuth In-Lieu Tax", key: "Housing Auth Welles Village" }],
      group: "housAuthInLieuTax",
      defaultVisible: true,
    },
    {
      key: "housAuthOtherProjects",
      label: "Other Housing Projects",
      valueType: "currency",
      sources: [{ block: "HousAuth In-Lieu Tax", key: "Other Housing Projects" }],
      group: "housAuthInLieuTax",
      defaultVisible: true,
    },

    // -------------------------
    // St Conn In-Lieu Taxes
    // (union of keys across years)
    // -------------------------
    {
      key: "stConnHomeownerTxRelief",
      label: "Home Owner Tax Relief",
      valueType: "currency",
      sources: [{ block: "St Conn In-Lieu Taxes", key: "homeownerTxRelief" }],
      group: "stConnInLieuTaxes",
      defaultVisible: true,
    },
    {
      key: "stConnDisabilityExemption",
      label: "Disability Exemption",
      valueType: "currency",
      sources: [{ block: "St Conn In-Lieu Taxes", key: "Disability Exemption" }],
      group: "stConnInLieuTaxes",
      defaultVisible: true,
    },
    {
      key: "stConnVeteransExemption",
      label: "Veterans Exemption",
      valueType: "currency",
      sources: [{ block: "St Conn In-Lieu Taxes", key: "Veterans Exemption" }],
      group: "stConnInLieuTaxes",
      defaultVisible: true,
    },
    {
      key: "stConnTelephoneAccess",
      label: "St/CT Telephone Access",
      valueType: "currency",
      sources: [{ block: "St Conn In-Lieu Taxes", key: "St/CT Telephone Access" }],
      group: "stConnInLieuTaxes",
      defaultVisible: true,
    },
    {
      key: "stConnStateStabilizationGrant",
      label: "State Stabilization Grant",
      valueType: "currency",
      sources: [{ block: "St Conn In-Lieu Taxes", key: "State Stabilization Grant" }],
      group: "stConnInLieuTaxes",
      defaultVisible: true,
    },
    {
      key: "stConnMiscStateGrant",
      label: "Miscellaneous State Grant",
      valueType: "currency",
      sources: [{ block: "St Conn In-Lieu Taxes", key: "Miscellaneous State Grant" }],
      group: "stConnInLieuTaxes",
      defaultVisible: true,
    },
    {
      key: "stConnPilot",
      label: "St/CT Pilot",
      valueType: "currency",
      sources: [{ block: "St Conn In-Lieu Taxes", key: "St/CT Pilot" }],
      group: "stConnInLieuTaxes",
      defaultVisible: true,
    },
    {
      key: "stConnMunicipalRevenueSharing",
      label: "Municpal Revenue Sharing",
      valueType: "currency",
      sources: [{ block: "St Conn In-Lieu Taxes", key: "Municpal Revenue Sharing" }],
      group: "stConnInLieuTaxes",
      defaultVisible: true,
    },

    // -------------------------
    // ST Educ Entitlements
    // -------------------------
    {
      key: "stEducMagnetTransportation",
      label: "Magnet School Transportation",
      valueType: "currency",
      sources: [{ block: "ST Educ Entitlements", key: "Magnet School Transportation" }],
      group: "stEducEntitlements",
      defaultVisible: true,
    },
    {
      key: "stEducEcsCostSharingGrant",
      label: "ECS Cost Sharing Grant",
      valueType: "currency",
      sources: [{ block: "ST Educ Entitlements", key: "ECS Cost Sharing Grant" }],
      group: "stEducEntitlements",
      defaultVisible: true,
    },
    {
      key: "stEducSpecEducExcessAgency",
      label: "Spec Educ Excess/Agency",
      valueType: "currency",
      sources: [{ block: "ST Educ Entitlements", key: "Spec Educ Excess/Agency" }],
      group: "stEducEntitlements",
      defaultVisible: true,
    },
    {
      key: "stEducVocationalAgriculture",
      label: "Vocational Agriculture",
      valueType: "currency",
      sources: [{ block: "ST Educ Entitlements", key: "Vocational Agriculture" }],
      group: "stEducEntitlements",
      defaultVisible: true,
    },

    // -------------------------
    // Admin Services
    // -------------------------
    {
      key: "adminStCtMotorVehicleGrant",
      label: "ST/CT Motor Vehicle Grant",
      valueType: "currency",
      sources: [{ block: "Admin Services", key: "ST/CT Motor Vehicle Grant" }],
      group: "adminServices",
      defaultVisible: true,
    },
    {
      key: "adminStCtHistoricalDocPres",
      label: "ST/CT Historical Document Pres",
      valueType: "currency",
      sources: [{ block: "Admin Services", key: "ST/CT Historical Document Pres" }],
      group: "adminServices",
      defaultVisible: true,
    },

    // -------------------------
    // Public Safety
    // -------------------------
    {
      key: "publicSafetyRegionalDispatchReimbursement",
      label: "Regional Dispatch Reimbursement",
      valueType: "currency",
      sources: [{ block: "Public Safety", key: "Regional Dispatch Reimbursement" }],
      group: "publicSafety",
      defaultVisible: true,
    },
    {
      key: "publicSafetyPoliceGrants",
      label: "Police Grants",
      valueType: "currency",
      sources: [{ block: "Public Safety", key: "Police Grants" }],
      group: "publicSafety",
      defaultVisible: true,
    },
    {
      key: "publicSafetyCivilPreparedness",
      label: "Civil Preparedness",
      valueType: "currency",
      sources: [{ block: "Public Safety", key: "Civil Preparedness" }],
      group: "publicSafety",
      defaultVisible: true,
    },
    {
      key: "publicSafetyStateFireService",
      label: "State Fire Service",
      valueType: "currency",
      sources: [{ block: "Public Safety", key: "State Fire Service" }],
      group: "publicSafety",
      defaultVisible: true,
    },
    {
      key: "publicSafetyVolunteerAmbulReimbursements",
      label: "Volunteer Ambul Reimbursements",
      valueType: "currency",
      sources: [{ block: "Public Safety", key: "Volunteer Ambul Reimbursements" }],
      group: "publicSafety",
      defaultVisible: true,
    },

    // -------------------------
    // Human Services
    // -------------------------
    {
      key: "humanServicesDialARideGrant",
      label: "Dial A Ride Grant",
      valueType: "currency",
      sources: [{ block: "Human Services", key: "Dial A Ride Grant" }],
      group: "humanServices",
      defaultVisible: true,
    },
    {
      key: "humanServicesHousingAuthResidentServices",
      label: "Housing Auth Resident Services",
      valueType: "currency",
      sources: [{ block: "Human Services", key: "Housing Auth Resident Services" }],
      group: "humanServices",
      defaultVisible: true,
    },
    {
      key: "humanServicesYouthFamilyStGrant",
      label: "Youth & Family ST Grant",
      valueType: "currency",
      sources: [{ block: "Human Services", key: "Youth & Family ST Grant" }],
      group: "humanServices",
      defaultVisible: true,
    },
    {
      key: "humanServicesNcaaGrant",
      label: "NCAA Grant",
      valueType: "currency",
      sources: [{ block: "Human Services", key: "NCAA Grant" }],
      group: "humanServices",
      defaultVisible: true,
    },
    {
      key: "humanServicesStateGrants",
      label: "State Grants",
      valueType: "currency",
      sources: [{ block: "Human Services", key: "State Grants" }],
      group: "humanServices",
      defaultVisible: true,
    },
  ],

  tables: [
    {
      id: "adopted",
      title: "Intergovernmental – Approved",
      sectionKey: "Approved",

      // Column order must match requested order
      fields: [
        // HousAuth In-Lieu Tax
        "housAuthWellesVillage",
        "housAuthOtherProjects",

        // St Conn In-Lieu Taxes
        "stConnHomeownerTxRelief",
        "stConnDisabilityExemption",
        "stConnVeteransExemption",
        "stConnTelephoneAccess",
        "stConnStateStabilizationGrant",
        "stConnMiscStateGrant",
        "stConnPilot",
        "stConnMunicipalRevenueSharing",

        // ST Educ Entitlements
        "stEducMagnetTransportation",
        "stEducEcsCostSharingGrant",
        "stEducSpecEducExcessAgency",
        "stEducVocationalAgriculture",

        // Admin Services
        "adminStCtMotorVehicleGrant",
        "adminStCtHistoricalDocPres",

        // Public Safety
        "publicSafetyRegionalDispatchReimbursement",
        "publicSafetyPoliceGrants",
        "publicSafetyCivilPreparedness",
        "publicSafetyStateFireService",
        "publicSafetyVolunteerAmbulReimbursements",

        // Human Services
        "humanServicesDialARideGrant",
        "humanServicesHousingAuthResidentServices",
        "humanServicesYouthFamilyStGrant",
        "humanServicesNcaaGrant",
        "humanServicesStateGrants",
      ],

      columnStyles: {
        year: { width: "100px", minWidthßß: "100px" },

        // HousAuth
        housAuthWellesVillage: { minWidth: "120px" },
        housAuthOtherProjects: { minWidth: "120px" },

        // St Conn In-Lieu Taxes
        stConnHomeownerTxRelief: { minWidth: "120px" },
        stConnDisabilityExemption: { minWidth: "110px" },
        stConnVeteransExemption: { minWidth: "110px" },
        stConnTelephoneAccess: { minWidth: "150px" },
        stConnStateStabilizationGrant: { minWidth: "160px" },
        stConnMiscStateGrant: { minWidth: "120px" },
        stConnPilot: { minWidth: "120px" },
        stConnMunicipalRevenueSharing: { minWidth: "160px" },

        // ST Educ Entitlements
        stEducMagnetTransportation: { minWidth: "120px" },
        stEducEcsCostSharingGrant: { minWidth: "120px" },
        stEducSpecEducExcessAgency: { minWidth: "120px" },
        stEducVocationalAgriculture: { minWidth: "120px" },

        // Admin
        adminStCtMotorVehicleGrant: { minWidth: "120px" },
        adminStCtHistoricalDocPres: { minWidth: "140px" },

        // Public Safety
        publicSafetyRegionalDispatchReimbursement: { minWidth: "160px" },
        publicSafetyPoliceGrants: { minWidth: "120px" },
        publicSafetyCivilPreparedness: { minWidth: "120px" },
        publicSafetyStateFireService: { minWidth: "120px" },
        publicSafetyVolunteerAmbulReimbursements: { minWidth: "160px" },

        // Human Services
        humanServicesDialARideGrant: { minWidth: "120px" },
        humanServicesHousingAuthResidentServices: { minWidth: "160px" },
        humanServicesYouthFamilyStGrant: { minWidth: "120px" },
        humanServicesNcaaGrant: { minWidth: "120px" },
        humanServicesStateGrants: { minWidth: "120px" },
      },
    },
    {
      id: "actual",
      title: "Intergovernmental – Actual",
      sectionKey: "Actual",

      // Same ordering
      fields: [
        "housAuthWellesVillage",
        "housAuthOtherProjects",

        "stConnHomeownerTxRelief",
        "stConnDisabilityExemption",
        "stConnVeteransExemption",
        "stConnTelephoneAccess",
        "stConnStateStabilizationGrant",
        "stConnMiscStateGrant",
        "stConnPilot",
        "stConnMunicipalRevenueSharing",

        "stEducMagnetTransportation",
        "stEducEcsCostSharingGrant",
        "stEducSpecEducExcessAgency",
        "stEducVocationalAgriculture",

        "adminStCtMotorVehicleGrant",
        "adminStCtHistoricalDocPres",

        "publicSafetyRegionalDispatchReimbursement",
        "publicSafetyPoliceGrants",
        "publicSafetyCivilPreparedness",
        "publicSafetyStateFireService",
        "publicSafetyVolunteerAmbulReimbursements",

        "humanServicesDialARideGrant",
        "humanServicesHousingAuthResidentServices",
        "humanServicesYouthFamilyStGrant",
        "humanServicesNcaaGrant",
        "humanServicesStateGrants",
      ],

      columnStyles: {
        year: { width: "100px", minWidthßß: "100px" },

        // HousAuth
        housAuthWellesVillage: { minWidth: "120px" },
        housAuthOtherProjects: { minWidth: "120px" },

        // St Conn In-Lieu Taxes
        stConnHomeownerTxRelief: { minWidth: "120px" },
        stConnDisabilityExemption: { minWidth: "110px" },
        stConnVeteransExemption: { minWidth: "110px" },
        stConnTelephoneAccess: { minWidth: "150px" },
        stConnStateStabilizationGrant: { minWidth: "160px" },
        stConnMiscStateGrant: { minWidth: "120px" },
        stConnPilot: { minWidth: "120px" },
        stConnMunicipalRevenueSharing: { minWidth: "160px" },

        // ST Educ Entitlements
        stEducMagnetTransportation: { minWidth: "120px" },
        stEducEcsCostSharingGrant: { minWidth: "120px" },
        stEducSpecEducExcessAgency: { minWidth: "120px" },
        stEducVocationalAgriculture: { minWidth: "120px" },

        // Admin
        adminStCtMotorVehicleGrant: { minWidth: "120px" },
        adminStCtHistoricalDocPres: { minWidth: "140px" },

        // Public Safety
        publicSafetyRegionalDispatchReimbursement: { minWidth: "160px" },
        publicSafetyPoliceGrants: { minWidth: "120px" },
        publicSafetyCivilPreparedness: { minWidth: "120px" },
        publicSafetyStateFireService: { minWidth: "120px" },
        publicSafetyVolunteerAmbulReimbursements: { minWidth: "160px" },

        // Human Services
        humanServicesDialARideGrant: { minWidth: "120px" },
        humanServicesHousingAuthResidentServices: { minWidth: "160px" },
        humanServicesYouthFamilyStGrant: { minWidth: "120px" },
        humanServicesNcaaGrant: { minWidth: "120px" },
        humanServicesStateGrants: { minWidth: "120px" },
      },
    },
  ],

  chartTitle: "Intergovernmental (Actual preferred)",
};

export function ProgramIntergovernmental(props) {
  return (
    <ProgramBudget
      programId="revenues_intergovernmental"
      config={PROGRAM_INTERGOVERNMENTAL_CONFIG}
      collectionName="townGovernment"
      {...props}
    />
  );
}
